var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('Notification',{attrs:{"notification":_vm.notification}}),(this.isAuthenticated)?_c('div',[_c('Header'),_c('v-content',[_c('v-container',[_c('router-view')],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }